module.exports = __webpack_public_path__ + "img/Logo-BNC.0a5c68f5.png";